<nb-card>
  <nb-card-header>{{ 'games.planning.propose_new_date' | translate }}</nb-card-header>
  <nb-card-body>
    <form id="propose-new-date-form" [formGroup]="proposeNewDateForm">

      <app-form-datetime-multiparts
        id="scheduled_start_time"
        [required]="true"
        [minDate]="minDate"
        [maxDate]="maxDate"
        formControlName="scheduled_start_time"/>

<!--      <app-form-datetime-->
<!--        id="scheduled_start_time"-->
<!--        label="DATE"-->
<!--        [required]="true"-->
<!--        placeholder="Pick date and time"-->
<!--        formControlName="scheduled_start_time"-->
<!--        [control]="getControl('scheduled_start_time')"></app-form-datetime>-->

    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="form-buttons">
      <button nbButton status="danger" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
      <button nbButton status="primary" (click)="submit()" [disabled]="!proposeNewDateForm.valid">{{ 'games.planning.propose_btn' | translate }}</button>
    </div>
  </nb-card-footer>
</nb-card>
